<template>
  <div>
    <div class="head">
      <div style="margin-left: 4%;float: left">Hebe Token Factory</div>
      <div style="float: right;margin-right: 4%">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color: #fff">
                Tool<i class="el-icon-arrow-down el-icon--right"></i>
           </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="">Home</el-dropdown-item>
            <el-dropdown-item command="multisenderetc">Etc MultiSender</el-dropdown-item>
            <el-dropdown-item command="multisenderetc1">Etc Customize MultiSender</el-dropdown-item>
            <el-dropdown-item command="multisendererc20">Erc20 MultiSender</el-dropdown-item>
            <el-dropdown-item command="multisendererc201">Erc20 Customize MultiSender</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="details">
      <div class="toptitle">
        <div style="margin-left: 20px">
          ETC Mordor Faucet
        </div>
      </div>
      <div style="width: 100%; background: rgb(255, 255, 255);">
        <div style="padding: 40px 20px;padding-top: 10px;">
          <div>
            <el-form v-loading="loading" :label-position="'top'" label-width="80px">

              <el-form-item label="Etc address">
                <el-input style="width: 98%" v-model="addr"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 20px">
                <el-button type="primary" @click="onSubmit">Submit</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const web3Utils = require('web3-utils')
  const axios = require('axios')
  const BN = require('bignumber.js')

  export default {
    name: 'multisender',
    data() {
      return {
        chains: [
          {
            'name': 'Ethereum Classic Mainnet',
            'chain': 'ETC',
            'rpc': ['https://etc.rivet.link'],
            'faucets': ['https://free-online-app.com/faucet-for-eth-evm-chains/?'],
            'nativeCurrency': { 'name': 'Ethereum Classic Ether', 'symbol': 'ETC', 'decimals': 18 },
            'infoURL': 'https://ethereumclassic.org',
            'shortName': 'etc',
            'chainId': 61,
            'networkId': 1,
            'slip44': 61,
            'explorers': [{ 'name': 'blockscout', 'url': 'https://blockscout.com/etc/mainnet', 'standard': 'none' }],
            'token': '0x591D3d94aa2C7eC90E0a49cf50928D1A48c4f6A5'
          },
          {
            'name': 'Ethereum Classic Testnet Mordor',
            'chain': 'ETC',
            'rpc': ['https://ethercluster.com/mordor'],
            'faucets': [],
            'nativeCurrency': { 'name': 'Mordor Classic Testnet', 'symbol': 'METC', 'decimals': 18 },
            'infoURL': 'https://github.com/eth-classic/mordor/',
            'shortName': 'metc',
            'chainId': 63,
            'networkId': 7,
            'explorers': [{ 'name': 'blockscout', 'url': 'https://blockscout.com/etc/mordor', 'standard': 'none' }],
            'token': '0x61fBa3b24C7b7a95588fbd1c2D207a904d495b98'
          }
        ],
        loading: false,
        form: {
          chain: 'Ethereum Classic Mainnet',
          addr: '',
          type: '',
          token: '',
          decimals: '18',
          sum: '',
          addrlist: '0x4f9C2C75d794F0aDb3BeB3398c5D8c552e4b64ba\ntest.etc\n' +
            '0x2573635A66Fa1192eFCbbF4EF45a796677d99f4b\n0x8828C116Dd7888F3A3Bd65E284E63Fc24Cb00deB'
        },
        addr: ''
      }
    },
    methods: {
      handleCommand(command) {
        this.$router.push({ path: '/' + command })
      },
      selectnetwork() {
        this.chains.forEach(item => {
          if (this.form.chain == item.name) {
            this.type = item.nativeCurrency.symbol
          }
        })
      },
      async onSubmit() {
        if (this.addr != '') {
          this.loading = true

          axios.post('https://etccooperative.org/mordor/faucet/v0/request', this.addr).then(res => {
            this.loading = false

            if (res.data.error) {
              this.$message.error(res.data.error)
            } else {
              this.$message.success(res.data.result)
            }
          }).catch(e=>{
            this.$message.error('error')
          })
        }
      },

      async addEthereumChain(model) {
        await ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: web3Utils.toHex(model.chainId),
              rpcUrls: model.rpc,
              chainName: model.name,
              nativeCurrency: {
                name: model.nativeCurrency.name,
                decimals: model.nativeCurrency.decimals,
                symbol: model.nativeCurrency.symbol
              },
              blockExplorerUrls: [model.explorers[0].url]
            }
          ]
        })
      },
      async getAddr() {
        return new Promise(async (resolve, reject) => {
          ethereum
            .request({ method: 'eth_requestAccounts' })
            .then((res) => {
              resolve(res[0])
            })
            .catch((err) => {
              resolve('')
            })
        })
      }
    },
    async mounted() {
      this.selectnetwork()
      let _this = this

      async function loginweb3() {
        if (typeof (ethereum) !== 'undefined') {
          _this.addr = await _this.getAddr()
          console.log(_this.form.addr)
          _this.$message.success('Connection succeeded')

        } else {
          // _this.$message.error('Please visit in an environment that supports metamask')
          setTimeout(() => {
            loginweb3()
          }, 1000)
        }
      }

      loginweb3()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px !important;
  }

  .el-form-item {
    margin-bottom: 6px !important;
  }

  .toptitle {
    border-radius: 0px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 10%) 0px 2px 12px 0px;
    margin-top: 10px;
    position: relative;
    background: rgb(250, 250, 250);
    overflow: hidden;
    height: 68px;
    line-height: 68px;
  }

  .details {
    max-width: 1180px;
    margin: 60px auto;
    padding-top: 20px;
  }

  .head {
    line-height: 60px;
    height: 60px;
    width: 100%;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    border-bottom: 1px solid #e5e5e5;
    background: #0299d8;
    background: -webkit-linear-gradient(45deg, #5a3694, #13bdce 33%, #0094d9 66%, #6fc7b5);
    background: -o-linear-gradient(45deg, #5a3694 0, #13bdce 33%, #0094d9 66%, #6fc7b5 100%);
    background: linear-gradient(45deg, #5a3694, #13bdce 33%, #0094d9 66%, #6fc7b5);
    background-size: 400%;
    background-position: 0 100%;
  }

  /* 防止用户自定义背景颜色对网页的影响，添加让用户可以自定义字体 */
  html {
    color: #000;
    background: rgb(240, 246, 250);;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-size: 100%;
  }

  /* 内外边距通常让各个浏览器样式的表现位置不同 */
  body, div, dl, dt, dd, ul, li, pre, form, fieldset, select, input, textarea, button, p, blockquote, th, td, img, iframe {
    margin: 0;
    padding: 0;
  }

  body {
    width: 100%;
    font-family: Overpass;
  }

  /* 要注意表单元素并不继承父级 font 的问题 */
  body, button, input, select, textarea {
    outline: none;
  }

  input, select, textarea {
    font-size: 100%;
  }

  /* 重置button边框 */
  button {
    border: none;
  }

  /* 去掉各Table cell 的边距并让其边重合 */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* IE bug fixed: th 不继承 text-align*/
  th {
    text-align: inherit;
  }

  /* 对齐是排版最重要的因素, 别让什么都居中 */
  caption, th {
    text-align: left;
  }

  /* 去除默认边框 */
  fieldset, img {
    border: none;
    outline: none;
    -moz-outline: none;
  }

  /* ie6 7 8(q) bug 显示为行内表现 */
  iframe {
    display: block;
  }

  /* 去掉列表前的标识, li 会继承 */
  ol, ul, li {
    list-style: none;
  }

  /* 来自yahoo, 让标题都自定义, 适应多个系统应用 */
  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-weight: 500;
    margin: 0;
    padding: 0;
  }

  /* 让链接默认不显示下划线，在hover状态下显示下划线 */
  a {
    color: #333;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    blr: expression(this.onFocus=this.blur());
  }

  a:hover {
    text-decoration: underline;
  }

  /* 清理浮动 */
  .clearfix:before, .clearfix:after {
    display: block;
    content: " ";
    clear: both;
  }

  .clearfix {
    zoom: 1; /* for ie67*/
  }

  /* 重设 HTML5 标签, IE 需要在 js 中 createElement(TAG) */
  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }

  /* HTML5 媒体文件跟 img 保持一致 */
  audio, canvas, video {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }

  address, caption, cite, code, dfn, em, th {
    font-style: normal;
    font-weight: normal;
  }

  /*解决盒模型问题css3属性也可用来统一FORM元素风格*/
  .box-sizing {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/faucet.vue